import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField, Chip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { fetchOrgTags } from '../store/actions';

var TAG_COLORS = [
    { bg: '#EFF6FF', text: '#2563EB' },  // blue
    { bg: '#F0FDF4', text: '#16A34A' },  // green
    { bg: '#FEF3C7', text: '#D97706' },  // amber
    { bg: '#FDF2F8', text: '#DB2777' },  // pink
    { bg: '#F5F3FF', text: '#7C3AED' },  // violet
    { bg: '#ECFDF5', text: '#059669' },  // emerald
    { bg: '#FFF7ED', text: '#EA580C' },  // orange
    { bg: '#F0F9FF', text: '#0284C7' },  // sky
    { bg: '#FEF2F2', text: '#DC2626' },  // red
    { bg: '#F8FAFC', text: '#475569' },  // slate
];

export var getTagColor = function(tag) {
    var hash = 0;
    for (var i = 0; i < tag.length; i++) {
        hash = ((hash << 5) - hash) + tag.charCodeAt(i);
        hash = hash & hash;
    }
    return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length];
};

const ClusterTagsInput = ({ tags, onChange, style }) => {
    const dispatch = useDispatch();
    const orgTags = useSelector(({ clusters }) => clusters.cluster.orgTags);
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        dispatch(fetchOrgTags());
    }, [dispatch]);

    var normalize = function(tagList) {
        var seen = {};
        var normalized = [];
        for (var i = 0; i < tagList.length; i++) {
            var tag = String(tagList[i]).toLowerCase().trim();
            if (tag && !seen[tag]) {
                seen[tag] = true;
                normalized.push(tag);
            }
        }
        return normalized;
    };

    var handleChange = function(_event, newValue) {
        onChange(normalize(newValue));
    };

    // Auto-commit typed text on blur (user clicks away or clicks submit without pressing Enter)
    var handleBlur = function() {
        var trimmed = inputValue.trim();
        if (trimmed) {
            var updated = normalize((tags || []).concat([trimmed]));
            onChange(updated);
            setInputValue('');
        }
    };

    return (
        <div style={style}>
            <Autocomplete
                multiple
                freeSolo
                autoSelect
                options={orgTags || []}
                value={tags || []}
                inputValue={inputValue}
                onInputChange={function(_event, newInputValue, reason) {
                    if (reason === 'reset') {
                        setInputValue('');
                    } else {
                        setInputValue(newInputValue);
                    }
                }}
                onChange={handleChange}
                onBlur={handleBlur}
                renderTags={function(value, getTagProps) {
                    return value.map(function(option, index) {
                        var tc = getTagColor(option);
                        return (
                            <Chip
                                key={option}
                                label={option}
                                size="small"
                                style={{
                                    backgroundColor: tc.bg,
                                    color: tc.text,
                                    fontWeight: 500,
                                    fontSize: '12px',
                                    height: '24px',
                                }}
                                {...getTagProps({ index: index })}
                            />
                        );
                    });
                }}
                renderInput={function(params) {
                    return (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Tags"
                            placeholder={tags && tags.length > 0 ? '' : 'Type to add tags...'}
                            helperText="Press Enter or click away to add a tag."
                        />
                    );
                }}
            />
        </div>
    );
};

export default ClusterTagsInput;
